"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { useWaitForTransactionReceipt } from "wagmi";
import { UnreachableCaseError } from "../../lib/errors";
export function useTransactionStatus(t0) {
  const $ = _c(6);
  const {
    transaction
  } = t0;
  const {
    getChainId
  } = useChains();
  const t1 = transaction.hash;
  let t2;
  if ($[0] !== getChainId || $[1] !== transaction.chain) {
    t2 = getChainId(transaction.chain);
    $[0] = getChainId;
    $[1] = transaction.chain;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      hash: t1,
      chainId: t2,
      pollingInterval: 100
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: receipt,
    isError
  } = useWaitForTransactionReceipt(t3);
  if (isError) {
    return "error";
  }
  const receiptStatus = receipt?.status;
  switch (receiptStatus) {
    case undefined:
      {
        return "pending";
      }
    case "success":
      {
        return "success";
      }
    case "reverted":
      {
        return "error";
      }
    default:
      {
        throw new UnreachableCaseError(receiptStatus);
      }
  }
}